import { Navigate } from 'react-router-dom';
import { getToken as getAuthToken } from 'api/auth';

export default function AlreadyAuthedAdmin({ children }) {
  const token = getAuthToken({ admin: true });
  // eslint-disable-next-line no-console
  console.log('[AlreadyAuthedAdmin] token?', !!token, 'path=', window.location.pathname);
  return token ? <Navigate to="/admin/dashboard" replace /> : children;
}
